import makeStyles from "@mui/styles/makeStyles";

export default makeStyles(
  (theme) => ({
    root: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      padding: [24, 34],
      width: 289,
      [theme.breakpoints.up("mobile")]: {
        width: 434,
        padding: [36, 50, 58],
      },
    },
    title: {
      marginBottom: 34,
      [theme.breakpoints.up("mobile")]: {
        marginBottom: 52,
      },
    },
    image: {
      width: 118,
      marginBottom: 34,
      [theme.breakpoints.up("mobile")]: {
        width: 177,
        marginBottom: 55,
      },
    },
  }),
  { name: "ShareModal-EmailForm-SuccessScheduled" },
);
